import React, {useState} from 'react';

const LocationInput = ({defaultVal, placeHolder, setCurrentOption}) => {

  const [value, setValue] = useState(defaultVal);

  return <input
    type="text"
    name="Location"
    placeholder={placeHolder}
    value={value}
    onChange={(e) => {
      setValue(e.target.value);
      setCurrentOption(e.target.value);
    }}/>

}

export default LocationInput;
